import React, { useEffect, useState } from 'react';
import toast from "react-hot-toast";
import { apiCallV2 } from "../../../utils/api";
import { read, utils } from 'xlsx';
import {
    CircularProgress,
} from '@mui/material';
import CustomTable from '../../../common/CustomTable';

import CustomUploadButton from '../../../common/CustomUploadButton/index'
import { RiLoader4Line, RiCheckLine, RiCloseLine } from "react-icons/ri";

const UploadNewList = ({ setAddOrgState, company }) => {
    const [buttonStatus, setButtonStatus] = useState('action')
    const [orgFile, setOrgFile] = useState('')
    const [employeeList, setEmployeeList] = useState([])


    const ExtensionChecker = (file) => {
        return file?.name.slice((Math.max(0, file?.name.lastIndexOf(".")) || Infinity) + 1);
    }

    // onchange event in submitting excel file of new organization
    const SetUploadedFile = async (e) => {
        let files = e.target.files;
        files = [...files]

        if (files.length > 0) {

            // check uploaded file if it is excel file
            let ExtensionCheck = ExtensionChecker(files[0])
            let allowedExtension = ["xlsx"]
            if (!allowedExtension.includes(ExtensionCheck)) {
                toast.error('Incorret File Type')
                return
            }
            setOrgFile(files[0])
            let reader = new FileReader();

            reader.onload = (e) => {
                let data = e.target.result;
                let workbook = read(data, {
                    type: 'binary'
                });


                workbook.SheetNames.forEach((sheetName, i) => {

                    // if (sheetName == "Sample") {
                    if (i === 0) {
                        let XL_row_object = utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);

                        // rename file properties
                        let newXL_row_object = XL_row_object.map(item => {
                            const { Department: department, "Employee Email*": employee_email, "Employee First*": employee_first, "Employee Last*": employee_last, "Mobile Number": mobile_number, "Work Location ": work_location, "Employee ID": employee_id, ...rest } = item;
                            return { department, employee_email, employee_first, employee_last, mobile_number, work_location, employee_id, ...rest }
                        })

                        // take out the last row of the array, for unnecessary value
                        let slicedXL_row_object = newXL_row_object.slice(0, newXL_row_object.length)
                        setEmployeeList(slicedXL_row_object)
                    }

                    if (sheetName === "indi-video-tracking") {
                        let XL_row_object = utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);

                        // rename file properties
                        let newXL_row_object = XL_row_object.map(item => {
                            return item;
                        })

                    }
                });
            };

            reader.readAsBinaryString(files[0]);

        }
        return;
    }

    const updateUserUploadingStatus = (index, fieldName, status) => {


        setEmployeeList(prev => {

            let employeeListTemp = [...prev];

            employeeListTemp[index] = {
                ...employeeListTemp[index],
                [fieldName + "Status"]: status,
            };

            return employeeListTemp;
        });
    }

    const handleSubmit = async () => {
        // validations open
        let flag = 0

        if (!employeeList) {
            toast.error('Empty Employee List!')
            flag = 1
        }

        if (flag === 1) {
            setButtonStatus('action')
            return
        }


        let successCounter = 0, successIndicator = employeeList.length * 4;

        for (let x = 0; x < employeeList.length; x++) {

            updateUserUploadingStatus(x, "indi", 1);
            updateUserUploadingStatus(x, "recurly", 1);
            updateUserUploadingStatus(x, "sendgrid", 1);


            const signupRes = await apiCallV2("POST", "admin/add-company-user", {
                user_name: employeeList[x].employee_first.toLowerCase().split(" ").join("").trim(" ") + "." + employeeList[x].employee_last.toLowerCase().split(" ").join("").trim(" "),
                email_address: employeeList[x].employee_email.trim(" "),
                user_type: 2, //1 is customer,0 is admin
                password: "12345!Qa",
                company: company.table_id,
                employee_id: employeeList[x].employee_id,

                first_name: employeeList[x].employee_first.trim(" "),
                last_name: employeeList[x].employee_last.trim(" "),
                work_location: employeeList[x].work_location,
                department: employeeList[x].department,

                mobile_number: employeeList[x].mobile_number ? (employeeList[x].mobile_number + "") : "",
                company_name: company.name,
                launch_date: company.launchDate,
            }, localStorage.getItem("access-token"));

            if (signupRes.status == 200 && signupRes.data.status == 200) {

                const message = signupRes.data.message.toLowerCase();
                successCounter += message.split("|").length;

                updateUserUploadingStatus(x, "sendgrid", (message.includes("sendgrid")) ? 2 : 0);
                updateUserUploadingStatus(x, "indi", (message.includes("indi")) ? 2 : 0);
                updateUserUploadingStatus(x, "recurly", (message.includes("recurly")) ? 2 : 0);

                updateUserUploadingStatus(x, "subscribe", 1);

                const resPurchase = await apiCallV2(
                    "POST",
                    "create-subscription",
                    {
                        first_name: employeeList[x].employee_first,
                        last_name: employeeList[x].employee_last,
                        currency: "USD",
                        plan_id: "",
                        billing_zip: "",
                        coupon_code: [],
                        startDate: new Date(company.launchDate),
                        renewal: false
                    },
                    signupRes.data.data.access_token
                );

                if (resPurchase.status == 200 && signupRes.data.status == 200) {

                    updateUserUploadingStatus(x, "subscribe", 2);
                    successCounter++;

                } else {
                    updateUserUploadingStatus(x, "subscribe", 0);
                    toast.error('Ops! Sorry, Something went wrong!')
                    setButtonStatus('action')
                }

            } else if (signupRes.status === 409) {
                updateUserUploadingStatus(x, "indi", 0);
                updateUserUploadingStatus(x, "sendgrid", 0);
                updateUserUploadingStatus(x, "recurly", 0);
                updateUserUploadingStatus(x, "subscribe", 0);
                updateUserUploadingStatus(x, "message", signupRes.data);
            } else {
                toast.error(`Failed Adding - ${employeeList[x].employee_first.trim(" ") + " " + employeeList[x].employee_last.trim(" ")}`)
                // setButtonStatus('action')
            }
        }


        if (successCounter === successIndicator) {

            // start: redirect after adding of employees all done
            toast.success('New Employee/s Added!')

            setButtonStatus('saved')

        } else {
            setButtonStatus('saved')
            toast.success('New Employee/s Added!')
            toast.error('Please check employee list status below');
        }
    }

    const handleConfirm = () => {
        setButtonStatus('loading')

        // asynchoronous call here
        handleSubmit()
    }


    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0)
    const [perPage, setPerPage] = useState(10)
    const handlePaginate = (e, v) => {
        if (v === page) {
            return
        }
        setPage(v)
    }

    useEffect(() => {
        setCount(employeeList.length)
    }, [employeeList])

    let start = (perPage * page) - perPage;
    let end = start + perPage;

    let employeeListFiltered = [...employeeList];

    if (search && search.length > 2) {
        employeeListFiltered = employeeListFiltered.filter(em => em.employee_first.includes(search) || em.employee_last.includes(search) || em.employee_email.includes(search));
    }

    employeeListFiltered = employeeListFiltered.slice(start, end);


    const statusIcons = [
        <RiCloseLine className="custom-cross-icon" />,
        <RiLoader4Line className="custom-loader-icon rotate" />,
        <RiCheckLine className="custom-check-icon" />,
    ]

    return (
        <div className='add-organization-wrapper'>
            <div id="new-org-form">
                <h4>ORGANIZATION UPLOAD</h4>
                
                <div id="nof-other-info">
                    <div className='nof-info-group'>
                        <div className='nof-info-label'>
                            <h5>EMPLOYEE LIST</h5>
                            <p>Attach your employee list for {company.name} below.</p>
                        </div>
                        <p className='input-file-text'>{orgFile?.name}</p>
                        <CustomUploadButton onChange={SetUploadedFile} />
                    </div>
                    <div className='nof-action'>
                        {buttonStatus === 'action' && (<button className='primary-button' onClick={() => setButtonStatus('confirm')}>SUBMIT</button>)}
                        {buttonStatus === 'confirm' && (<button className='primary-button' onClick={handleConfirm}>CONFIRM</button>)}
                        {buttonStatus === 'loading' && (<button className='primary-button' onClick={() => { }}><CircularProgress sx={{ color: '#fff' }} /></button>)}
                        {buttonStatus === 'saved' && (<button className='primary-button' onClick={() => setButtonStatus('action')}>SUCCESS!</button>)}
                    </div>

                    <div>
                        {
                            employeeListFiltered.length > 0 &&
                            <CustomTable
                                title={"List of Employees (" + employeeListFiltered.length + ")"}
                                description=""
                                list={employeeListFiltered}
                                table={{
                                    headers: [
                                        { title: "#" },
                                        { title: "Employee ID", },
                                        { title: "Name", },
                                        { title: "Email", },
                                        { title: "Mobile Number", },
                                        { title: "Work Location", },
                                        { title: "Department", },
                                        { title: "INDI", },
                                        { title: "RECURLY", },
                                        { title: "SENDGRID", },
                                        { title: "SUBSCRIBED", },
                                        { title: "MESSAGE", },
                                    ],
                                    body: (emp, i) => {
                                        return (
                                            <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                                <td><h6>{i + start}</h6></td>
                                                <td><h6>{emp.employee_id}</h6></td>
                                                <td><h6>{emp.employee_first.trim(" ") + " " + emp.employee_last.trim(" ")}</h6></td>
                                                <td><h6>{emp.employee_email}</h6></td>
                                                <td><h6>{emp.mobile_number}</h6></td>
                                                <td><h6>{emp.work_location}</h6></td>
                                                <td><h6>{emp.department}</h6></td>
                                                <td><h6>{statusIcons[emp?.indiStatus]}</h6></td>
                                                <td><h6>{statusIcons[emp?.recurlyStatus]}</h6></td>
                                                <td><h6>{statusIcons[emp?.sendgridStatus]}</h6></td>
                                                <td><h6>{statusIcons[emp?.subscribeStatus]}</h6></td>
                                                <td><h6 className='error-txt'>{emp?.messageStatus}</h6></td>
                                            </tr>
                                        )
                                    }
                                }}
                                pagination={{
                                    page: page,
                                    count: count,
                                    perPage: perPage,
                                    paginate: handlePaginate,
                                    setPerPage: (val) => {
                                        setPerPage(val);
                                    }
                                }}
                                actions={{
                                    search: {
                                        onChange: (e) => {
                                            setSearch(e.target.value);
                                        },
                                        onClick: () => { }
                                    }
                                }}
                            />
                        }

                    </div>
                </div>
            </div>

        </div >
    );
};

export default UploadNewList;